import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight, faBars, faCirclePlus, faCircleMinus, faHeart } from '@fortawesome/free-solid-svg-icons';
library.add(faArrowRight, faBars, faCirclePlus, faCircleMinus, faHeart);